<template>

<div class="bar-center" v-if="!$isMobile">

	<slot></slot>

</div>

</template>

<script>

export default {

}

</script>

<style scoped>

.bar-center {
	display: flex;
	justify-content: center;
}

</style>
